import React from "react";

const Loading = () => {
  return (
    <div className="preloader">
      <div className="loader">
        <div className="sh1" />
        <div className="sh2" />
      </div>
    </div>
  );
};

export default Loading;
